import { Form, Select } from "antd";
import DateIcon from "../_icons/DateIcon";
import { QuestionTypeProps } from "../_types/type";

export default function DateField({ index }: QuestionTypeProps) {
  return (
    <div className="mt-6 text-sm font-medium text-display-body">
      <Form.Item
        name={[index, "question_type_date"]}
        // valuePropName="checked"
        className="mb-0"
        initialValue={"YYYY-MM-DD"}
      >
        <Select
          placeholder="Year, Month, Day"
          optionFilterProp="children"
          suffixIcon={<DateIcon />}
          size="middle"
          options={[{ label: "Year, Month, Day", value: "YYYY-MM-DD" }]}
          className="select-border-none max-w-[500px] min-w-60 md:min-w-[500px]"
        />
      </Form.Item>
    </div>
  );
}
